import type { RouterConfig } from '@nuxt/schema'
import { ru } from 'vuetify/locale'
export default {
  // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
  routes: (routes) => {
    if(routes.some(r=>r.path.indexOf('/:lang')>-1) == false){
      var rutas = routes.slice()
      for (const ruta of rutas) {
        if(ruta.path.indexOf('/:lang')==-1) {
          var r = { ...ruta }
          r.name = "lang-" + (r.name)
          r.path = "/:lang([a-z]{2})?" + ruta.path
          routes.push(r)
        }
      }
    } 
    
    return routes
  },
  scrollBehaviorType: "smooth"
} satisfies RouterConfig